define((require) => {
    "use strict";

    const ImprovedModel             = require("shared/zbone/ImprovedModel");
    const ShareRecipientCollection  = require("ui/share/ShareRecipientCollection");
    const SendEmail                 = require("ui/editor/email/SendEmail");
    const EMAIL_STATES              = require("ui/editor/email/Constants");

    /**
     * The view model for sending test emails.
     *
     * @class RecipientsPopupModel
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            state: EMAIL_STATES.CLOSE,
            recipients: null
        },

        initialize: function() {
            this._reset();
            this.listenTo(this, "change:state", this._stateChangeHandler);
        },

        _reset: function() {
            this.set({
                recipients: new ShareRecipientCollection()
            });
        },

        _onGetActionWidgetsBoundingBoxes(widgetBoxes) {
            this.set({state: EMAIL_STATES.PROCESSING_EMAIL});
            this.get("emailSliceModel").fetch({widgets: widgetBoxes}).then((model) => {
                const toAddresses = new Set();
                this.get("recipients").each((recipient) => {
                    if (recipient.get("email") && recipient.get("selected")) {
                        toAddresses.add(recipient.get("email"));
                    }
                });
                const sender = new SendEmail({
                    companyId: this.get("experienceModel").get("companyId"),
                    htmlBody: model.get("tableHTML"),
                    toAddresses: Array.from(toAddresses).join(","),
                    subjectLine: this.get("subjectLine")
                });
                sender.save()
                    .then(
                        ()=> {
                            return model.get("sizeWarning")
                                ? this.set({state: EMAIL_STATES.SENT_EMAIL_WITH_SIZE_WARNING})
                                : this.set({state: EMAIL_STATES.SENT_EMAIL});
                        },
                        ()=> this.set({state: EMAIL_STATES.ERROR_EMAIL})
                    );
            }, ()=>this.set({state: EMAIL_STATES.ERROR_EMAIL}));
        },

        _stateChangeHandler: function() {
            if (this.get("state") === EMAIL_STATES.SEND_EMAIL) {
                const scenes = this.get("experienceModel").get("scenes");
                scenes.trigger("getEmailActionWidgetsBoundingBoxes", this._onGetActionWidgetsBoundingBoxes.bind(this));
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/RecipientsPopupModel.js